export const hasReachedEnd = ({
  scrollTop,
  // For more information: https://developer.mozilla.org/fr/docs/Web/API/Element/scrollHeight
  scrollHeight,
  // For more information: https://developer.mozilla.org/fr/docs/Web/API/Element/clientHeight
  clientHeight,
  endZoneSize,
}: {
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
  endZoneSize: number;
}) => {
  const nonVisibleContentHeight = scrollHeight - clientHeight;

  return scrollTop > 0 && scrollTop >= nonVisibleContentHeight - endZoneSize;
};
